import {isShapeTallCabinet} from "./cabinetBoxCompatibilityHelper";
import {getShape3dModelUrl} from "./sqft3dArHelper";
import {getCabinetInteriorHeight} from "./tallCabinetInteriorHelper";
import {getCabinetSectionsFromModel} from "../components/ar3d/threeD/glbViewer/scene/modelsLoader/cabinetInterior/cabinetSectionsParser";
import {buildLayoutFromGlbSections} from "../components/navigation/menuRight/Attributes/helpers/cabinetInteriorLayoutHelper";

const pendingLayoutByShape = new WeakMap();

// Loads the model-authored closet layout when no 3D cabinet instance exists yet.
export const loadCabinetInteriorLayoutForShape = async (shape) => {
  if (!isShapeTallCabinet(shape) || !shape.shapeCabinet) {
    return null;
  }

  const existingLayout = shape.shapeCabinet.getCabinetInteriorLayout();
  if (existingLayout && existingLayout.isEditableInterior) {
    return existingLayout;
  }

  if (pendingLayoutByShape.has(shape)) {
    return pendingLayoutByShape.get(shape);
  }

  const layoutPromise = getCabinetSectionsFromModel(getShape3dModelUrl(shape))
    .then((sections) => {
      if (!sections || sections.length === 0) {
        return null;
      }

      return buildLayoutFromGlbSections(
        sections,
        getCabinetInteriorHeight(shape.getHeight())
      );
    });

  pendingLayoutByShape.set(shape, layoutPromise);

  try {
    return await layoutPromise;
  } finally {
    pendingLayoutByShape.delete(shape);
  }
};
